import { useLocation, useNavigate } from 'react-router-dom';
import { ManageSmartAssistantTabSlug, ROUTE_LINKS } from 'shared/constants/route-links';
import { SMART_ASSISTANT_MANAGE_TABS_BY_TYPE } from 'shared/constants/smart-assistant';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface UseManageSmartAssistantTabsParams {
  smartAssistant: SmartAssistant;
}

export function useManageSmartAssistantTabs({ smartAssistant }: UseManageSmartAssistantTabsParams) {
  const location = useLocation();
  const navigate = useNavigate();

  const allAvailableTabs = SMART_ASSISTANT_MANAGE_TABS_BY_TYPE[smartAssistant.type];

  // Extract current tab from path: /dashboard/agent/manage/[smartAssistantId]/[tabSlug]
  const pathSegments = location.pathname.split('/');
  const tabSlugFromPath = pathSegments[5] || '';
  const tabSlug = tabSlugFromPath as ManageSmartAssistantTabSlug;

  // Validate that the current tab exists in available tabs
  const currentTab = allAvailableTabs.includes(tabSlug) ? tabSlug : undefined;

  const handleTabChange = (tabSlug: ManageSmartAssistantTabSlug | null) => {
    const targetTab = tabSlug || allAvailableTabs[0];
    navigate(`${ROUTE_LINKS.manageSmartAssistant}/${smartAssistant._id}/${targetTab}`);
  };

  return {
    allAvailableTabs,
    currentTab,
    handleTabChange
  };
}
